// extracted by mini-css-extract-plugin
export default {"root":"IconFileSignature_root__Gvp0Z"};